/* eslint-disable @typescript-eslint/ban-types */
import React, { useCallback, useEffect, useState } from 'react'
import api from '../../../../../services/api'
import Form, { Input, Select } from '../../../../../components/Form'
import Button from '../../../../../components/Button'
import { useHistory } from 'react-router-dom'
import { useToast } from '../../../../../hooks/toast'
import { useLoading } from '../../../../../hooks/loading'
import { useUpdateDataTable } from '../../../../../hooks/dataTable'
import { FormDataProtocol } from '../../domain/protocols'
import { apiCreate, apiUpdate } from '../../domain/api'
import { nameActions } from '../../domain/info'
import { filterDuplicatedsObject } from '../../../../../utlis/filterDuplicatesObject'

type IsOpenInModalProps = {
  idParent: number
  handleOnClose: () => void
}

type TypesFormProps = {
  // eslint-disable-next-line @typescript-eslint/ban-types
  valueInput?: object
  isOpenInModal?: false | IsOpenInModalProps
  typeForm:
    | 'create'
    | {
        idUpdate: number
        inputValue: string
        idParentUpdate?: string
      }
}

interface PermissionData {
  name: string
  description: string
  method: string
  base_url: string
  path?: string
  grouped: string
  function: string
}

type Permission = {
  name: string
  grouped?: string
  function?: string
  id: number
}

export const FormCategory = ({
  isOpenInModal,
  typeForm,
  valueInput
}: TypesFormProps): JSX.Element => {
  const { addToast } = useToast()
  const history = useHistory()
  const { updateDataTable } = useUpdateDataTable()

  const { activeLoading, disableLoading } = useLoading()
  const [permissionsGrouped, setPermissionsGrouped] = useState<Permission[]>([])

  const loadPermissions = useCallback(async () => {
    activeLoading()
    try {
      const { data } = await api.get('/users/permissions')
      setPermissionsGrouped(filterDuplicatedsObject(data, 'grouped'))
      disableLoading()
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Erro ao carregar as permissões',
        description:
          'Ocorreu um erro ao carregar as permissões, por favor, tente novamente.'
      })
      disableLoading()
    }
  }, [activeLoading, addToast, disableLoading])

  useEffect(() => {
    loadPermissions()
  }, [loadPermissions])

  const onSubmitForm = async (data: FormDataProtocol) => {
    try {
      if (typeForm === 'create') {
        if (isOpenInModal) {
          const { handleOnClose } = isOpenInModal
          const dataCreate: PermissionData = {
            ...data,
            path: data.path?.length ? data.path : null
          }
          activeLoading()
          try {
            await api.post(apiCreate(), dataCreate)
            handleOnClose()
            disableLoading()
            updateDataTable()
          } catch (error) {
            addToast({
              type: 'error',
              title: 'Erro ao adicionar a permissão',
              description:
                'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
            })
            handleOnClose()
            disableLoading()
            updateDataTable()
          }
        } else {
          try {
            const dataCreate: PermissionData = {
              ...data,
              path: data.path?.length ? data.path : null
            }
            activeLoading()
            await api.post(apiCreate(), dataCreate)
            disableLoading()
            history.push(nameActions.read.to)
          } catch (error) {
            addToast({
              type: 'error',
              title: 'Erro ao adicionar a permissão',
              description:
                'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
            })
            disableLoading()
            updateDataTable()
          }
        }
      } else {
        if (isOpenInModal) {
          const { handleOnClose } = isOpenInModal
          const id = typeForm.idUpdate
          const dataUpdate: PermissionData = {
            ...data,
            path: data.path?.length ? data.path : null
          }

          try {
            activeLoading()
            await api.put(apiUpdate(String(id)), dataUpdate)
            updateDataTable()
            disableLoading()
            handleOnClose()
            addToast({
              type: 'success',
              title: 'Permissão atualizado',
              description: 'Permissão alterado com sucesso'
            })
          } catch (error) {
            disableLoading()
            handleOnClose()
            addToast({
              type: 'error',
              title: 'Erro ao atualizar  a permissão',
              description:
                'Ocorreu um erro ao fazer a atualização, por favor, tente novamente.'
            })
          }
        } else {
          const dataUpdate: PermissionData = {
            ...data,
            path: data.path?.length ? data.path : null
          }
          const id = typeForm.idUpdate

          try {
            activeLoading()
            await api.put(apiUpdate(String(id)), dataUpdate)
            updateDataTable()
            disableLoading()
            history.push(nameActions.read.to)
            addToast({
              type: 'success',
              title: 'Permissão atualizado',
              description: 'Permissão alterado com sucesso'
            })
          } catch (error) {
            history.push(nameActions.read.to)
            addToast({
              type: 'error',
              title: 'Erro ao atualizar a permissão',
              description:
                'Ocorreu um erro ao fazer a atualização, por favor, tente novamente.'
            })
          }
        }
      }
      disableLoading()
    } catch (err) {
      if (typeForm === 'create') {
        addToast({
          type: 'error',
          title: 'Erro no cadastro',
          description:
            'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
        })
        if (isOpenInModal) isOpenInModal.handleOnClose()
      }
    }
  }

  return (
    <Form onSubmit={onSubmitForm} defaultValues={valueInput}>
      <>
        <div className="form-body">
          <div className="row">
            <div className="col-md-4">
              <Input
                name="name"
                className="form-control"
                label="Nome"
                rules={{ required: true }}
              />
            </div>
            <div className="col-md-4">
              <Input
                name="base_url"
                className="form-control"
                label="URL de Base"
                rules={{ required: true }}
              />
            </div>

            <div className="col-md-2">
              <Input
                name="path"
                className="form-control"
                label="Caminho"
                rules={{ required: false }}
              />
            </div>

            <div className="col-md-2">
              <Select
                name="method"
                className="form-control"
                label="Método"
                rules={{ required: true }}
                options={[
                  {
                    name: 'SELECIONE',
                    value: 'SELECIONE'
                  },
                  {
                    name: 'GET',
                    value: 'GET'
                  },
                  {
                    name: 'POST',
                    value: 'POST'
                  },
                  {
                    name: 'PUT',
                    value: 'PUT'
                  },
                  {
                    name: 'DELETE',
                    value: 'DELETE'
                  },
                  {
                    name: 'PATCH',
                    value: 'PATCH'
                  }
                ]}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-3">
              <Select
                name="grouped"
                className="form-control"
                label="Grupo"
                defaultValue=""
                blank
                options={permissionsGrouped.map(
                  item =>
                    item && {
                      name: item.grouped.toUpperCase(),
                      value: item.grouped.toUpperCase()
                    }
                )}
                rules={{ required: true }}
              />
            </div>
            <div className="col-md-3">
              <Input
                name="function"
                className="form-control"
                label="Função"
                rules={{ required: true }}
              />
            </div>
          </div>
          <div className="form-body">
            <div className="row">
              <div className="col-md-12">
                <Input
                  name="description"
                  className="form-control"
                  label="Descrição"
                  rules={{ required: true }}
                />
              </div>
            </div>
          </div>
        </div>
        {isOpenInModal && typeForm === 'create' ? (
          <hr className="divider" />
        ) : (
          <div style={{ margin: '10px 0' }} />
        )}
        <div className="form-actions right">
          {isOpenInModal && (
            <button
              onClick={isOpenInModal.handleOnClose}
              type="reset"
              className="btn btn-default btn-sm sbold uppercase"
            >
              Fechar
            </button>
          )}
          <Button type="submit" className="btn dark btn-sm sbold uppercase">
            Salvar
          </Button>
        </div>
      </>
    </Form>
  )
}
